import { API_GET_LIST_PROFESSIONAL_PROPOSAL_RFP_SUCCESS, API_GET_LIST_PROFESSIONAL_RFP_SUCCESS, } from '../actions/ProfessionalMySolutionRfpActions';
const INITIAL_STATE = {
    proposals: [],
    rfps: {},
    rfpsTotal: 0,
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { meta, payload, total, type }) => {
    switch (type) {
        case API_GET_LIST_PROFESSIONAL_PROPOSAL_RFP_SUCCESS: {
            return Object.assign(Object.assign({}, state), { proposals: payload.list });
        }
        case API_GET_LIST_PROFESSIONAL_RFP_SUCCESS: {
            return Object.assign(Object.assign({}, state), { rfps: Object.assign(Object.assign({}, state.rfps), { [meta.page]: payload.list }), rfpsTotal: total });
        }
        default: {
            return state;
        }
    }
};
